class PrintoutLanguageDialogResult {
    constructor() {

        /** @type {Boolean}  */
        this.shouldRemember = false;

        /** @type {String}  */
        this.language = null;

        /** @type {Object}  */
        this.form = {};

        /** @type {String}  */
        this.printout = null;

        /** @type {Array}  */
        this.selectionLocal = [];

    }
}

export { PrintoutLanguageDialogResult }